import { PdfItem } from '../../pages/pdf/types';

interface Props {
  data: PdfItem['data'];
}

export const PdfParagraph = ({ data }: Props) => {
  const { content } = data;

  return <p className="px-2">{content}</p>;
};
